<div class="ellipsis-container">
  @if (headerTemplate) {
    <div class="ellipsis-header">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </div>
  }

  <div
    class="text-content"
    [class.is-collapsed]="!isExpanded"
    [style.height]="currentHeight"
    #contentContainer
  >
    <ng-content></ng-content>
  </div>

  @if (isExpandable) {
    <div class="expand-toggle">
      <hyperkit-link
        class="toggle-link"
        variant="emphasized"
        size="sm"
        align="left"
        color="primary"
        [text]="isExpanded ? collapsedText : expandedText"
        (click)="toggleExpanded()"
      ></hyperkit-link>
    </div>
  }
</div>
